<div class="d-flex justify-content-center align-items-center w-100 h-100">
    <div class="col-xl-4 col-md-6 col-10">
        <div class="card border-0 box-shadow rounded-0">
            <div class="card-header d-flex justify-content-center align-items-center border-white text-primary bg-white">
                <h2>Register member</h2>
            </div>
            <div class="card-body text-center pb-1">
               
                <a routerLink="/login" class="transition text-warning">Already have an account? Sign in!</a>

                <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" class="text-left mt-4">
                    <div class="form-group">
                        <input [formControl]="name" class="form-control validation-field" placeholder="Full Name" type="text"> 
                        <small class="text-danger" *ngIf="form.get('name').touched">
                            <span *ngIf="form.get('name').hasError('required')">Full Name is required</span>
                            <span *ngIf="form.get('name').hasError('minlength')">Minimum of 3 characters</span>
                        </small>       
                    </div>
                    <div class="form-group">
                        <input [formControl]="email" class="form-control validation-field" placeholder="Email" type="text"> 
                        <small class="text-danger" *ngIf="form.get('email').touched">
                            <span *ngIf="form.get('email').hasError('required')">Email is required</span>
                            <span *ngIf="form.get('email').hasError('invalidEmail')">Invalid email address</span>
                        </small> 
                    </div>
                    <div class="form-group">
                        <input [formControl]="password" class="form-control validation-field" placeholder="Password" type="password" minlength="6">
                         <small class="text-danger" *ngIf="form.get('password').touched">
                            <span *ngIf="form.get('password').hasError('required')">Password is required</span>
                            <span *ngIf="form.get('password').hasError('minlength')">Password isn't long enough, minimum of 6 characters</span>
                        </small>                     
                    </div>
                    <div class="form-group">
                        <input [formControl]="confirmPassword" class="form-control validation-field" placeholder="Confirm Password" type="password">
                        <small class="text-danger" *ngIf="form.get('confirmPassword').touched">
                            <span *ngIf="form.get('confirmPassword').hasError('required')">Confirm Password is required</span>
                            <span *ngIf="form.get('confirmPassword').hasError('mismatchedPasswords')">Passwords do not match</span>
                        </small> 
                    </div>
                    <div class="form-group">
                        <p class="terms">By creating an account, you agree our <a class="transition terms" href="javascript:void(0);">Terms & Privacy Policy</a></p>                  
                    </div>             
                    <div class="form-group">
                        <button  class="btn btn-block bg-primary text-white" type="submit">Sign up</button>
                    </div>
                </form>  
            </div>
        </div>
    </div>
</div>
